import React from 'react';
import { AccountAvatar } from '@michelin/acid-components';
import { TechServiceAreaLocation } from '../types';

export function LocationAvatar({
  location,
}: {
  location: TechServiceAreaLocation;
}) {
  return (
    <div
      style={{
        borderRight: '1px solid #e0e0e0',
        paddingRight: 16,
        marginRight: 8,
        float: 'left',
      }}
    >
      <AccountAvatar
        accountType="ST"
        name={location?.customer_dba_name || location?.customer_name || ''}
        accountNumbers={{
          shipTo:
            location?.ship_to_number || location?.customer_number || undefined,
          billTo: undefined,
          mdm: undefined,
        }}
        addressDisplay="cityState"
        address={{
          address1: location?.customer_addr1,
          address2: location?.customer_addr2,
          city: location?.customer_city,
          state: location?.customer_state,
          zip: location?.customer_zip,
        }}
      />
    </div>
  );
}
